module.exports = __webpack_public_path__ + "assets/img/18-s.9f9ff72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/18-s.jpg
// module id = VUX9
// module chunks = 0